export const BUS_EVENTS = {
  SET_REFERRER_HOST: 'SET_REFERRER_HOST',
  SET_TWEET_REPLY: 'SET_TWEET_REPLY',
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  SHOW_CONTACT_FORM: 'SHOW_CONTACT_FORM',
  PRE_CHAT_FORM_CHAT_SUCCESS: 'PRE_CHAT_FORM_CHAT_SUCCESS',
  CHAT_CONTACT_FORM_SUBMIT: 'CHAT_CONTACT_FORM_SUBMIT',
  CHAT_CONTACT_FORM_SUBMIT_RESET_STATE: 'CHAT_CONTACT_FORM_SUBMIT_RESET_STATE',
  CHAT_CONTACT_FORM_SUBMIT_SUCCESS: 'CHAT_CONTACT_FORM_SUBMIT_SUCCESS',
};
